import * as React from 'react';
import { TileLayer } from 'react-leaflet';
import { useDisplayPreferences } from '../../displayPreferences-context';
import { getTileLayerUrl } from './get-tile-layer-url';
export function BuildingBaseLayer({ theme }) {
    const tileset = `base_${theme}`;
    const { editableBuildings } = useDisplayPreferences();
    if (editableBuildings == "enabled") {
        return React.createElement(TileLayer, { key: theme, url: getTileLayerUrl(tileset), minZoom: 9, maxZoom: 19, detectRetina: false });
    }
    else {
        return React.createElement("div", null);
    }
}
